import useAlerts from './useAlerts';
import useGlobalUrl from '@/composables/useGlobalUrl';
import useSilentAccessToken from './useSilentAccessToken';

const { addAlert } = useAlerts();
const { leadFileUrl } = useGlobalUrl();

export default function useLeadFiles() {
  async function uploadLeadFiles(files, leadid, interactionid, showCompletedAlert) {
    const { getAccessToken } = useSilentAccessToken();
    const token = await getAccessToken();

    try {
      for (var i = 0; i < files.length; i++) {
        if (files && files[i]) {
          const formData = new FormData();
          formData.append('file', files[i]);
          const result = await fetch(`${leadFileUrl}/upload?leadid=${leadid}${interactionid ? `&interactionid=${interactionid}` : ''}`, {
            method: 'POST',
            headers: {
              Authorization: token ? `Bearer ${token}` : '',
            },
            body: formData,
          });
          if (!result.ok) throw new Error('Error saving file');
        }
      }
      if (showCompletedAlert) addAlert('File saved', 'low', 3);
    } catch (error) {
      console.error(error);
      addAlert('Error saving file', 'high', 4);
    }
  }

  async function deleteFile(leadid, filename) {
    const { getAccessToken } = useSilentAccessToken();
    const token = await getAccessToken();

    try {
      const result = await fetch(`${leadFileUrl}/delete?leadid=${leadid}&filename=${encodeURIComponent(filename)}`, {
        method: 'POST',
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      });
      if (!result.ok) throw new Error('Error deleting file');
    } catch (error) {
      console.error(error);
      addAlert('Error deleting file', 'high', 4);
    }
  }

  async function renameFile(leadid, filename, newFilename) {
    const { getAccessToken } = useSilentAccessToken();
    const token = await getAccessToken();

    try {
      const result = await fetch(`${leadFileUrl}/rename?leadid=${leadid}&filename=${encodeURIComponent(filename)}&newfilename=${encodeURIComponent(newFilename)}`, {
        method: 'POST',
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      });
      if (!result.ok) throw new Error('Error renaming file');
    } catch (error) {
      console.error(error);
      addAlert('Error renaming file', 'high', 4);
      return false;
    }
    return true;
  }

  async function getFile(leadid, filename, interactionid = null) {
    const { getAccessToken } = useSilentAccessToken();
    const token = await getAccessToken();

    try {
      const result = await fetch(`${leadFileUrl}/download`, {
        method: 'POST',
        body: JSON.stringify({
          leadid,
          filename,
          interactionid,
        }),
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
          'Content-Type': 'application/json',
        },
      });
      if (!result.ok) throw new Error('Error downloading file');
      const blob = await result.blob();
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error(error);
      addAlert('Error downloading file', 'high', 4);
    }
  }

  return { uploadLeadFiles, deleteFile, renameFile, getFile };
}
